import {
  Box,
  Column,
  Columns,
  Divider,
  Heading,
  Hidden,
  IconTick,
  Stack,
  Text,
} from 'braid-design-system';
import React from 'react';

import { TRACKING_CODES } from 'src/shared/constant';

import { CONCIERGE_URL } from '../../../../../../shared/links';
import CTAButtonNoLinks from '../../../../branding/App/components/CTAButtonNoLinks';

const Concierge = () => (
  <Box
    borderRadius="large"
    boxShadow="borderNeutralLight"
    padding="medium"
    paddingY="large"
  >
    <Stack space="large">
      <Columns
        collapseBelow="desktop"
        space={{ desktop: 'xxlarge', mobile: 'large' }}
        alignY="center"
      >
        <Column>
          <Stack space="medium">
            <Heading level="3" align={{ desktop: 'left', mobile: 'center' }}>
              Concierge
            </Heading>
            <Text
              align={{ desktop: 'left', mobile: 'center' }}
              size="large"
              tone="secondary"
            >
              A job writing expert can optimise your ad to help you attract the
              right type of candidates
            </Text>
          </Stack>
        </Column>
        <Column width="content">
          <CTAButtonNoLinks
            text={{
              loggedIn: 'Enquire about Concierge',
              loggedOut: 'Enquire about Concierge',
            }}
            href={{
              loggedIn: CONCIERGE_URL,
              loggedOut: CONCIERGE_URL,
            }}
            tracking={{
              loggedIn: TRACKING_CODES.concierge_link_clicked,
              loggedOut: TRACKING_CODES.sign_in_link_clicked,
            }}
            variant="ghost"
            tone="formAccent"
          />
        </Column>
      </Columns>
      <Hidden below="desktop">
        <Divider />
      </Hidden>
      <Columns
        collapseBelow="desktop"
        space={{ desktop: 'medium', mobile: 'large' }}
        alignY="bottom"
      >
        <Column width="3/4">
          <Stack space="large" align="left">
            <Text size="large" weight="strong">
              Everything in Premium, plus...
            </Text>
            <Stack space="medium" align="left">
              <Text icon={<IconTick tone="formAccent" />} size="standard">
                Experts write your ad
              </Text>
              <Text icon={<IconTick tone="formAccent" />} size="standard">
                We post the Job Ad for you
              </Text>
            </Stack>
          </Stack>
        </Column>
        <Column>
          <Text
            align={{ desktop: 'right', mobile: 'left' }}
            size="small"
            tone="secondary"
          >
            Not available for all job types
          </Text>
        </Column>
      </Columns>
    </Stack>
  </Box>
);

export default Concierge;
